import { Controller } from "@hotwired/stimulus"
import TomSelect from "@lib/custom-tom-select"

// Connects to data-controller="resource-select"
export default class extends Controller {
  static targets = ["select"]
  
  connect() {
    if (this.hasSelectTarget) { this.setupSelect() }
  }

  setupSelect() {
    // Destroy existing Tom Select instance if it exists (e.g., from previous connection)
    if (this.selectTarget.tomselect) {
      this.selectTarget.tomselect.destroy()
    }

    this.select = new TomSelect(this.selectTarget, {
      load: this.loadResources.bind(this),
      valueField: "value",
      labelField: "label",
      searchField: "label",
      shouldLoad: function(query) {
        return true;  // Always trigger the load function (so we can clear the options on blank queries)
      }
    })
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
    }
  }

  async loadResources(query, callback) {
    this.select.clearSelect()
    if (!query.trim()) {
      callback([])
      return
    }
    
    const resourceTypes = ["Client", "Animal"]
    const queryUrl = `/search?q=${query}&${resourceTypes.map((type) => `resource_types[]=${type}`).join("&")}`
    const response = await fetch(queryUrl, { headers: { accept: "application/json" } })
    const data = await response.json()
    const results = data.map((item) => ({
      label: [item.prefix, item.label].filter(x => x).join(" — "),
      value: item.dom_id,
      appliedLabel: item.label,
    }))
    callback(results)
  }
  
}
